<template>
  <div class="activity-container">
    <div class="custom-header">
      <div class="options">
        <multiselect
          v-model="selected"
          deselect-label="Can't remove this value"
          track-by="name"
          label="name"
          placeholder="Activity"
          :options="activityTypes"
          :searchable="false"
          :allow-empty="false"
        ></multiselect>
        <multiselect
          v-model="selectedYear"
          deselect-label="Can't remove this value"
          track-by="name"
          label="name"
          placeholder="Year"
          :options="years"
          :searchable="false"
          :allow-empty="false"
        ></multiselect>
      </div>
    </div>

    <div class="tbl-container">
      <div class="card-row">
        <info-card
          :title="'Total Distance'"
          :sub_title="totalDistance + ' KM'"
          :border_location="'left'"
          :color="'#FF008E'"
          :border_color="'#FF008E'"
        ></info-card>
        <info-card
          :title="'Average Distance'"
          :sub_title="avgDistance + ' KM'"
          :border_location="'left'"
          :color="'#39FF14'"
          :border_color="'#39FF14'"
        ></info-card>
        <info-card
          :title="'Longest Distance'"
          :sub_title="longestDistance + ' KM'"
          :border_location="'left'"
          :color="'#00ffe5'"
          :border_color="'#00ffe5'"
        ></info-card>
        <info-card
          :title="'Monthly Average'"
          :sub_title="averages.monthly + ' KM'"
          :border_location="'left'"
          :color="'#2343F3'"
          :border_color="'#2343F3'"
        ></info-card>
        <info-card
          :title="'Weekly Average'"
          :sub_title="averages.weekly + ' KM'"
          :border_location="'left'"
          :color="'#A819FD'"
          :border_color="'#A819FD'"
        ></info-card>
        <info-card
          :title="'Total Time'"
          :sub_title="totalTime"
          :border_location="'left'"
          :color="'#1cc88a'"
          :border_color="'#1cc88a'"
        ></info-card>
        <info-card
          :title="'Total Elevation Gain'"
          :sub_title="totalElevation + ' M'"
          :border_location="'left'"
          :color="'#c0e218'"
          :border_color="'#c0e218'"
        ></info-card>
        <info-card
          :title="'Total Calories'"
          :sub_title="totalCalories + ' KCAL'"
          :border_location="'left'"
          :color="'#F93319'"
          :border_color="'#F93319'"
        ></info-card>
      </div>
    </div>
    <div class="grid-container">
      <div
        :key="index"
        :value="chart.name"
        v-for="(chart, index) in this.charts.filter(
          (property) => property.show !== false
        )"
      >
        <div class="chart-container">
          <div class="Chart__title__header">
            <span class="Chart__title">{{ chart.title }}</span>
            <div v-if="chart.showOptions">
              <select
                class="gradient-select"
                :id="chart.id"
                v-model="chart.selectedOption"
                @change="onChange($event)"
              >
                <option v-for="opt in chart.options" :key="opt" :value="opt">
                  {{ opt }}
                </option>
              </select>
            </div>

            <div class="Chart__header__actions" v-if="chart.useMeasure">
              <div>
                <button
                  class="filter-button"
                  type="button"
                  v-for="option in chart.measures"
                  @click="chart.selectedMeasure.value = option.value"
                  :key="option.value"
                  v-bind:class="{
                    selected: chart.selectedMeasure.value == option.value,
                  }"
                >
                  {{ option.name }}
                </button>
              </div>
            </div>
          </div>
          <hr class="chart-hr" />
          <div class="Chart__content" v-if="chart.type == 'bar'">
            <apex-bar
              :chart-data="chart.data"
              :chart-labels="chart.labels"
              :colors="chart.color"
              :border="chart.border"
              :tooltip-color="chart.tooltip"
              :emoji="chart.emoji"
              :chart-data-type="chart.dataType"
              :xAxisTicks="chart.xAxisTicks"
              :rotate="chart.rotate"
              :horizontal="chart.horizontal"
              :yAxisTitle="chart.yAxisTitle"
              :startAt="0"
              :label-color="chart.labelColor"
            />
          </div>
          <div class="Chart__content" v-if="chart.type == 'area'">
            <apex-area
              :chart-data="chart.data"
              :chart-labels="chart.labels"
              :colors="chart.color"
              :border="chart.border"
              :tooltip-color="chart.tooltip"
              :emoji="chart.emoji"
              :chart-data-type="chart.dataType"
              :xAxisTicks="chart.xAxisTicks"
              :xAxisLabel="chart.xAxisLabel"
              :label-color="chart.labelColor"
              :yAxisTitle="chart.yAxisTitle"
            />
          </div>
          <div class="Chart__content" v-if="chart.type == 'line'">
            <apex-line-series
              :chart-data="chart.data"
              :chart-labels="chart.labels"
              :colors="chart.color"
              :border="chart.border"
              :tooltip-color="chart.tooltip"
              :emoji="chart.emoji"
              :chart-data-type="chart.dataType"
              :yAxisTitle="chart.yAxisTitle"
              :label-color="chart.labelColor"
            ></apex-line-series>
          </div>
          <div class="Chart__content" v-if="chart.type == 'scatter-pace'">
            <apex-scatter
              :min-y="200"
              :format-label="true"
              :chart-data="chart.data"
              :colors="chart.color"
              :border="chart.border"
              :tooltip-color="chart.tooltip"
              :emoji="chart.emoji"
              :chart-data-type="chart.dataType"
              :label-color="chart.labelColor"
              :yAxisTitle="chart.yAxisTitle"
              :xAxisLabel="chart.xAxisLabel"
            />
          </div>
          <div class="Chart__content" v-if="chart.type == 'scatter'">
            <apex-scatter
              :min-y="0"
              :format-label="false"
              :chart-data="chart.data"
              :colors="chart.color"
              :border="chart.border"
              :tooltip-color="chart.tooltip"
              :emoji="chart.emoji"
              :chart-data-type="chart.dataType"
              :label-color="chart.labelColor"
              :yAxisTitle="chart.yAxisTitle"
              :xAxisLabel="chart.xAxisLabel"
            />
          </div>
          <div class="Chart__content" v-if="chart.type == 'donut'">
            <apex-donut
              :chart-data="chart.data"
              :chart-labels="chart.labels"
              :colors="chart.color"
              :border="chart.border"
              :tooltip-color="chart.tooltip"
              :emoji="chart.emoji"
              :chart-data-type="chart.dataType"
              :label-color="chart.labelColor"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="chart" v-if="!this.loading">
      <div class="chart-container">
        <div class="Chart__title__header">
          <span class="Chart__title"
            >{{ this.seletedType.name }} {{ this.seletedMeasure.name }} per
            country (athlete location)</span
          >
        </div>
        <div class="Chart__header__actions">
          <div>
            <button
              class="filter-button"
              type="button"
              v-for="option in measure"
              @click="setFilter(option, 'measure')"
              :key="option.value"
              v-bind:class="{
                selected: seletedMeasure.value == option.value,
              }"
            >
              {{ option.name }}
            </button>
          </div>
          <div>
            <button
              class="filter-button"
              type="button"
              v-for="option in types"
              @click="setFilter(option, 'type')"
              :key="option.value"
              v-bind:class="{
                selected: seletedType.value == option.value,
              }"
            >
              {{ option.name }}
            </button>
          </div>
        </div>
        <hr />
        <apex-line
          :title="'Athlete week over week'"
          :chartData="kmByCountryCumulativeOverWeek.data"
          :chartLabels="kmByCountryCumulativeOverWeek.labels"
          :colors="[
            '#C60B30',
            '#FF3F00',
            '#DD153C',
            '#8B75D7',
            '#003580',
            '#FECB02',
            '#096954',
          ]"
          :border="'#FF0000'"
          :tooltip="'#FF0000'"
          :type="'line'"
          :showOptions="true"
          :xAxisTitle="'Week'"
          :yAxisTitle="this.yAxisTitle"
          :yAxisUnit="this.yAxisUnit"
        ></apex-line>
      </div>
    </div> -->
  </div>
</template>


<script>
var _ = require("lodash");
import { dataFormat } from "@/mixins/dataFormat";

import moment from "moment";
const humanizeDuration = require("humanize-duration");

import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ActivityRepository = RepositoryFactory.get("activities");

import { activityTypes } from "@/data/activities.js";
import { secsToPace } from "@/utils/timeUtil.js";
import { generateWeekOptions } from "@/utils/dateUtil.js";
import { HSLToRGB } from "@/utils/util.js";

import InfoCard from "@/components/Cards/InfoCard.vue";
// import TabList from "@/components/Tablist";
// import CustomSelect from "@/components/Select";

// import ApexLine from "@/components/Charts/ApexLine.vue";
import ApexBar from "@/components/Charts/ApexBar.vue";
import ApexDonut from "@/components/Charts/ApexDonut";

export default {
  name: "Stats",
  mixins: [dataFormat],
  components: { InfoCard, ApexDonut, ApexBar },
  methods: {
    async fetchActivities(type, year) {
      console.log("Fetching activities for year:" + year);
      try {
        const { data } = await ActivityRepository.get(type, year);
        return data;
      } catch (err) {
        console.log(err);
      }
    },
    fieldFn(rowObj) {
      return secsToPace(rowObj.avg_speed);
    },
    setFilter(value, filter) {
      if (filter == "type") {
        this.seletedType = value;
      }
      if (filter == "measure") {
        this.yAxisTitle = this.seletedMeasure.name;
        this.seletedMeasure = value;
      }
      if (filter == "activityType") {
        this.id = value;
      }
    },
  },

  data() {
    return {
      showAll: false,
      id: "",
      yAxisTitle: "Distance",
      yAxisUnit: "KM",
      loading: false,
      activityTypes: activityTypes,
      activities: [],
      runPerDistanceBinSize: 3,
      currentActivityType: {},
      selectedYear: { name: "2023", value: "2023" },
      years: [
        { name: "2022", value: 2022 },
        { name: "2023", value: 2023 },
        { name: "All", value: "all" },
      ],
      selected: { name: "Walk", id: "walk" },
      seletedType: { name: "Cumulative", value: "cumulative" },
      seletedMeasure: { name: "Distance", value: "distance", unit: "KM" },
      types: [
        { name: "Cumulative", value: "cumulative" },
        { name: "Weekly", value: "weelky" },
      ],
      measure: [
        { name: "Distance", value: "distance", unit: "KM", showFor: [0, 1] },
        {
          name: "Elevation",
          value: "total_elevation_gain",
          unit: "M",
          showFor: [0, 1],
        },
      ],
      color: {
        hue: 50,
        saturation: 100,
        luminosity: 50,
        alpha: 1,
      },
      weeks: generateWeekOptions()
        .map((week) => week.value)
        .filter((week) => week != "all"),
    };
  },
  created() {
    this.currentActivityType = this.activityTypes.filter(
      (act) => act.id.toLowerCase() == this.selected.id.toLowerCase()
    )[0];
    this.fetchActivities(
      this.currentActivity.value,
      this.selectedYear.value
    ).then((result) => (this.activities = result));
  },
  mounted() {
    this.$on("item-selected", (selection) => {
      this.selected = selection;
    });
  },
  computed: {
    currentActivity() {
      return this.activityTypes.filter(
        (act) => act.value.toLowerCase() == this.selected.id.toLowerCase()
      )[0];
    },
    charts() {
      let charts = [
        {
          title: `Activity types`,
          data: this.sportTypes.data,
          labels: this.sportTypes.labels,
          color: "#FF0000",
          border: "#FF0000",
          tooltip: "#FF0000",
          emoji: "🏃‍♂️",
          type: "donut",
          dataType: "Year",
          show: this.sportTypes.data.length > 1,
          xAxisTicks: 15,
          showOptions: false,
          labelColor: "#FFF",
        },
        {
          title: `${this.selected.name} by country (location)`,
          data: this.locations.data,
          labels: this.locations.labels,
          color: "#FF0000",
          border: "#FF0000",
          tooltip: "#FF0000",
          emoji: "🏃‍♂️",
          type: "donut",
          dataType: "Year",
          show: true,
          xAxisTicks: 15,
          labelColor: "#FFF",
          showOptions: false,
          useMeasure: false,
          selectedMeasure: {
            name: "Distance",
            value: "distance",
            field: "distance",
            unit: "KM",
            startAt: 0,
          },
          measures: [
            {
              name: "Distance",
              value: "distance",
              field: "distance",
              unit: "KM",
              startAt: 0,
            },
            {
              name: "Count",
              value: "count",
              field: "count",
              unit: "",
              startAt: 0,
            },
          ],
        },
        {
          title: `${this.selected.name} per distance`,
          id: "distance-bin",
          data: this.runsPrDistance.data,
          labels: this.runsPrDistance.labels,
          color: this.chartColor,
          colors: ["#F55555", "#6078ea", "#6094ea"],
          border: "#FF0000",
          tooltip: "#FF0000",
          emoji: "🏃‍♂️",
          type: "bar",
          dataType: "Year",
          show: true,
          xAxisTicks: 15,
          xAxisRotate: -45,
          yAxisTitle: `Count`,
          rotate: true,
          showOptions: false,
          horizontal: false,
          selectedOption: this.currentActivityType.defaultBinsize,
          options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          labelColor: "#FFF",
        },
        {
          title: `${this.selected.name} per weekday`,
          id: "distance-bin",
          data: this.activityPerDayInWeek.data,
          labels: this.activityPerDayInWeek.labels,
          color: this.chartColor,
          colors: ["#F55555", "#6078ea", "#6094ea"],
          border: "#FF0000",
          tooltip: "#FF0000",
          emoji: "🏃‍♂️",
          type: "bar",
          dataType: "Year",
          show: true,
          xAxisTicks: 15,
          xAxisRotate: -45,
          yAxisTitle: `Count`,
          rotate: true,
          showOptions: false,
          horizontal: false,
          selectedOption: this.currentActivityType.defaultBinsize,
          options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          labelColor: "#FFF",
        },
      ];

      return charts;
    },
    leaderboard() {
      let dataByAthlete = _.groupBy(this.activities, "athlete.id");
      let newData = [];
      Object.values(dataByAthlete).forEach((athlete) => {
        let avg = athlete.map((item) => item.average_pace_seconds);
        let maxDist = _.maxBy(athlete, "distance");

        newData.push({
          athlete: athlete[0].athlete.id,
          distance: Number(
            athlete
              .map((item) => item.distance / 1000)
              .reduce(function (previousValue, currentValue) {
                return previousValue + currentValue;
              })
              .toFixed(2)
          ),
          avg_distance: Number(
            _.mean(athlete.map((item) => item.distance / 1000)).toFixed(2)
          ),
          elev_gain: Number(
            athlete
              .map((item) => item.total_elevation_gain)
              .reduce(function (previousValue, currentValue) {
                return previousValue + currentValue;
              })
          ),
          longest: Number((maxDist.distance / 1000).toFixed(2)),
          avg_speed: Math.round(_.mean(avg)),
          activities: athlete.length,
        });
      });

      return newData;
    },
    totalDistance() {
      let data = this.activities;
      var dist = data.reduce((sum, { distance }) => sum + Number(distance), 0);

      return (dist / 1000).toFixed(2);
    },
    avgDistance() {
      let data = this.activities.map((act) => act.distance / 1000);

      var dist = _.mean(data);

      return dist.toFixed(2);
    },
    longestDistance() {
      let max = _.max(this.activities.map((act) => act.distance / 1000));
      if (max != undefined) {
        return max.toFixed(2);
      }
      return 0;
    },
    averages() {
      let data = this.activities;
      let averages = {
        weekly: 0,
        monthly: 0,
        yearly: 0,
      };

      if (data.length > 0) {
        var totalDist = data.reduce(
          (sum, { distance }) => sum + Number(distance / 1000),
          0
        );

        let ordered = _.orderBy(data, "start_date", "asc");
        var firstDay = new moment(ordered[0].start_date);
        var currDay = new moment();

        let diff = moment.duration(currDay.diff(firstDay));

        averages.weekly = (
          totalDist.toFixed(2) / diff.asWeeks().toFixed(0)
        ).toFixed(2);
        averages.monthly = (
          totalDist.toFixed(2) / Math.ceil(diff.asMonths())
        ).toFixed(2);
        averages.yearly = (
          totalDist.toFixed(2) / Math.ceil(diff.asYears())
        ).toFixed(2);
      }

      return averages;
    },
    totalTime() {
      let data = this.activities;
      let time =
        data.reduce((sum, { moving_time }) => sum + moving_time, 0) * 1000;

      let timeHuman = humanizeDuration(time, { units: ["h"], round: true });

      return timeHuman;
    },
    totalElevation() {
      let data = this.activities;

      return _.sumBy(data, "total_elevation_gain").toFixed(2);
    },
    totalCalories() {
      let data = this.activities;

      return _.sumBy(data, "calories").toFixed(2);
    },
    kmByCountryCumulativeOverWeek() {
      let type = this.seletedType.value;
      let measureBy = this.seletedMeasure.value;

      let combData = [];

      let data = this.activities;
      data.forEach((act) => {
        act.week = moment(act.start_date).format("WW");
      });

      let groupedByCountry = _.groupBy(data, "athlete_location");

      for (let country in groupedByCountry) {
        let weeklyData = _.groupBy(groupedByCountry[country], "week");
        let count = new Array(this.weeks.length).fill(0);
        for (let w in this.weeks) {
          let week = this.weeks[w];
          let weeklySum = _.sumBy(weeklyData[week], measureBy);
          if (measureBy == "time") {
            weeklySum = weeklySum / 3600000;
          }
          if (measureBy == "distance") {
            weeklySum = weeklySum / 1000;
          }

          count[w] = weeklySum;
        }
        if (type == "cumulative") {
          for (var i = 1; i < count.length; i++) {
            count[i] += count[i - 1];
          }
        }

        if (country == null || country == "null") {
          country = "Unknown";
        }

        combData.push({
          label: country,
          name: country,
          data: count,
          fill: false,
          borderColor: "#FF0000",
        });
      }

      return {
        data: combData,
        labels: this.weeks,
      };
    },
    sportTypes() {
      let data = this.activities;

      // return _.groupBy(data, "sport_type");

      let locs = _(data)
        .groupBy("sport_type")
        .map((value, key) => ({
          country: key,
          total: value.length,
        }))
        .value();

      let sportTypes = {
        data: locs.map((item) => item.total),
        labels: locs.map((item) => item.country),
      };

      return sportTypes;
    },
    locations() {
      let data = this.activities.filter(
        (act) =>
          act.activity_location != "Error" && act.activity_location != "N/A"
      );

      const locs = _(data)
        .groupBy("activity_location")
        .map((value, key) => ({
          country: key,
          total: value.length,
        }))
        .value();

      // const ans = _(data)
      //   .groupBy("activity_location")
      //   .map((country, id) => ({
      //     country: id,
      //     distance: _.sumBy(country, "distance") / 1000,
      //   }))
      //   .value();

      const locations = {
        data: locs.map((item) => item.total),
        labels: locs.map((item) => item.country),
      };

      return locations;
    },
    workoutType() {
      let data = this.activities;

      return _.groupBy(data, "workout_type");
    },
    activityPerDayInWeek() {
      const dayIndexes = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];

      let data = this.activities;
      let dates = data.map((entry) =>
        new moment(entry.start_date).format("dddd")
      );

      var count = [];
      var uniq = _.uniq(dates);

      uniq.forEach((item) => {
        count.push({
          order: dayIndexes.indexOf(item),
          labels: item,
          data: dates.filter((entry) => entry == item).length,
        });
      });

      count = _.orderBy(count, "order");

      return {
        data: count.map((item) => item.data),
        labels: count.map((item) => item.labels),
      };
    },
    runsPrDistance() {
      let count = [];
      let labels = [];
      let data = this.activities.filter((act) => act.distance != undefined);

      let distances = data.map((entry) => ({
        distance: Math.round(entry.distance / 1000),
        span: this.getRange(
          Math.floor(entry.distance / 1000),
          this.currentActivityType.defaultBinSize
        ),
      }));

      var result = _.groupBy(distances, "span");

      var keysSorted = Object.keys(result).sort(function (a, b) {
        var distA = a.split("-")[0];
        var distB = b.split("-")[0];

        return distA - distB;
      });

      for (var key in keysSorted) {
        var keyIndex = keysSorted[key];

        count.push(result[keyIndex].length);
        labels.push(keyIndex);
      }

      return {
        data: count,
        labels: labels,
      };
    },

    chartColor() {
      var hue = this.color.hue;
      var rgb = HSLToRGB(Math.floor(hue), 100, 50);
      return rgb;
    },
  },
  watch: {
    selected: function () {
      this.loading = true;
      this.fetchActivities(
        this.currentActivity.value,
        this.selectedYear.value
      ).then((result) => (this.activities = result));
      this.currentActivityType = this.activityTypes.filter(
        (act) => act.id.toLowerCase() == this.selected.toLowerCase()
      )[0];

      this.loading = false;
    },
    selectedYear: function () {
      this.loading = true;

      this.fetchActivities(
        this.currentActivity.value,
        this.selectedYear.value
      ).then((result) => (this.activities = result));

      this.currentActivityType = this.activityTypes.filter(
        (act) => act.id.toLowerCase() == this.selected.toLowerCase()
      )[0];

      this.loading = false;
    },
  },
};
</script>
<style scoped>
.activity-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.custom-header {
  min-height: 50px;
  width: 90%;
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0px;
  padding: 5px;
  background-color: #262635;
}

.options {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  column-gap: 10px;
  padding: 5px;
  width: 30rem;
}

h1,
h3 {
  color: #fff;
}

.card-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  justify-content: center;
  margin-top: 25px;
}

.card-col {
  flex: 1 0 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/**
GRID CONTAINER
*/
.grid-container {
  width: 90%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(33%, 1fr));
  grid-row-gap: 1em;
  grid-column-gap: 1em;
}

@media only screen and (max-width: 768px) {
  .grid-container {
    display: grid;
    grid-row-gap: 1em;
    grid-column-gap: 1em;
    grid-template-columns: repeat(1, minmax(1px, 1fr));
  }
}

@media only screen and (min-width: 769) {
  .grid-container {
    display: grid;
    grid-row-gap: 1em;
    grid-column-gap: 1em;
    grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  }
}

@media only screen and (min-width: 1601) {
  .grid-container {
    display: grid;
    grid-row-gap: 1em;
    grid-column-gap: 1em;
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
}

.chart-container {
  background-color: #313144;
}

.Chart__title__header {
  background-color: #262635;
  color: #fff;
  display: flex;
  flex-direction: row;
  margin-bottom: 1.25rem;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 10px;
}
.Chart__header__actions {
  display: flex;
  flex-direction: row;
  margin-bottom: 1.25rem;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 10px;
}

.Chart__content {
  height: auto;
}

.Chart__title {
  text-transform: uppercase;
  margin-left: 15px;
  font-weight: 600;
  font-size: 1.2rem;
}

.filter-button {
  border-color: #ffffff;
  color: #ffffff;
  border: 1px solid;
  margin-right: 5px;
  background-color: transparent;
  min-height: 35px;
  min-width: 100px;
}
.selected {
  background: linear-gradient(
    90deg,
    rgba(254, 87, 46, 1) 0%,
    rgba(255, 146, 63, 1) 100%
  );
  color: #fff;
}

.fancy {
  font-size: 2vw;
  text-transform: uppercase;
  text-align: center;
  line-height: 1;
  background-image: url("data:image/svg+xml,%3Csvg width='2250' height='900' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath fill='%2300A080' d='M0 0h2255v899H0z'/%3E%3Ccircle cx='366' cy='207' r='366' fill='%2300FDCF'/%3E%3Ccircle cx='1777.5' cy='318.5' r='477.5' fill='%2300FDCF'/%3E%3Ccircle cx='1215' cy='737' r='366' fill='%23008060'/%3E%3C/g%3E%3C/svg%3E%0A");
  background-size: 110% auto;
  background-position: center;
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}
</style>
